import { KineticModule, PrivilegeType } from '@kinetic-ui/data-layer';
import { EntityTypes } from 'const';
import { Privileges } from 'contexts';

// Check if user has privileges for a specific entityId
export const hasEntityPrivilege = (
  userPrivileges: Privileges,
  privilegeType: PrivilegeType,
  module: KineticModule | string,
  entityType: EntityTypes,
  entityId: string
) => {
  const privilege = userPrivileges?.[module]?.[privilegeType]?.[0];

  if (!privilege) {
    return false;
  }

  // If restrictedEntities is not defined or empty, user has access to all entities
  if (!privilege.restrictedEntities || Object.keys(privilege.restrictedEntities).length === 0) {
    return true;
  }

  return privilege.restrictedEntities[entityType]?.includes(entityId);
};
